var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 /* no local variables */ 
__p+='\n\n<div class="qv-payment-calculator">\n  <div class="panel">\n    <div class="accordion-heading collapsed" role="tab" data-toggle="collapse" href="#collapse-payment" aria-expanded="false" aria-controls="collapse-payment" data-omtag="ldp:payment-calculator:expand">\n      <h2 class="title-section accordion-title">\n      <i class="ra ra-payment-options"></i>Monthly Payment\n      </h2>\n      <p class="sec-summary ellipsis" id="estimate-payment-summary">\n        Monthly estimate not available\n      </p>\n    </div>\n    <div id="collapse-payment" class="panel-collapse collapse" role="tabpanel" aria-labelledby="collapsePayment">\n      ';
 /* panel body */ 
__p+='\n      <div class="component_placeholder">\n        <div class="loader"></div>\n      </div>\n    </div>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/payment/panel.jst.ejs